import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages, Check } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguageSwitcher } from '../utils/i18n';
import { apiService } from '../services/api';
import { SUPPORTED_LOCALES, type SupportedLocale } from '../config/shellConfig';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';

export const LanguageMenu: React.FC = () => {
  const { i18n } = useTranslation();
  const { switchLanguage } = useLanguageSwitcher();
  const { user } = useAuth();

  const handleLanguageChange = async (lang: SupportedLocale) => {
    switchLanguage(lang);

    if (user?.id) {
      try {
        await apiService.users.updateProfile({ preferredLanguage: lang });
      } catch (error) {
        console.error('Failed to save language preference:', error);
      }
    }
  };

  return (
    <div className="hidden md:flex items-center">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" aria-label="Language">
            <Languages className="size-5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-44">
          {SUPPORTED_LOCALES.map((locale) => (
            <DropdownMenuItem 
              key={locale.code} 
              onClick={() => handleLanguageChange(locale.code)}
              className="flex items-center justify-between"
            >
              <span>{locale.label}</span>
              {i18n.language === locale.code && (
                <Check className="size-4 ml-2" />
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
